import { HttpClient } from '@angular/common/http';
import { effect, Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OfficeTemplatesService } from './office-templates.service';
import { Assembly } from 'src/app/models/assembly.model';
import { tap } from 'rxjs';
import { StandardAssembly } from '@/models/standard-template.model';

@Injectable({
  providedIn: 'root'
})
export class OfficeTemplatesAssembliesService {
  BASEURL = environment.landmark_API_URL + '/standards/assemblies';

  constructor(
    private http: HttpClient,
    private officeTemplatesService: OfficeTemplatesService
  ) {
   }

   addAssembly(assembly: Partial<StandardAssembly>) {
    this.http.post<StandardAssembly>(this.BASEURL, assembly).subscribe(assembly => {
      this.officeTemplatesService.updateTemplate({
        StandardAssemblies: [...(this.officeTemplatesService.selectedTemplate()?.StandardAssemblies || []), assembly]
      });
    });
   }

   addAssemblies(assemblies: Assembly[]) {
    const ssid = this.officeTemplatesService.selectedTemplate()?.SSID;
    const fid = this.officeTemplatesService.selectedTemplate()?.FID;
    const standardAssemblies = assemblies.map(assembly => ({
      AID: assembly.AID,
      SSID: ssid
    }));
    return this.http.post<StandardAssembly>(this.BASEURL+'/batch', {assemblies:standardAssemblies, ssid:ssid, fid:fid}).pipe(
      tap(assemblies => {
      this.officeTemplatesService.updateTemplate({
        StandardAssemblies: [...(this.officeTemplatesService.selectedTemplate()?.StandardAssemblies || []), assemblies]
      });
   })
  );
  }

  updateAssemblyQuantity(assembly: StandardAssembly, quantity: number) {
    this.http.patch<StandardAssembly>(`${this.BASEURL}/${assembly.SAID}`, {quantity: quantity}).subscribe(assembly => {
      this.officeTemplatesService.updateTemplate({
        StandardAssemblies: this.officeTemplatesService.selectedTemplate()?.StandardAssemblies.map(a => a.SAID === assembly.SAID ? assembly : a) || []
      });
    });
  }

   removeAssembly(assembly: StandardAssembly) {
    this.http.delete<StandardAssembly>(`${this.BASEURL}/${assembly.SAID}`).subscribe(assembly => {
      this.officeTemplatesService.updateTemplate({ 
        StandardAssemblies: this.officeTemplatesService.selectedTemplate()?.StandardAssemblies.filter(a => a.SAID !== assembly.SAID) || []
      });
    });
   }

   modifyAssembly(assembly: StandardAssembly) {
    this.http.put<StandardAssembly>(`${this.BASEURL}/${assembly.SAID}`, assembly).subscribe(assembly => {
      this.officeTemplatesService.updateTemplate({
        StandardAssemblies: this.officeTemplatesService.selectedTemplate()?.StandardAssemblies.map(a => a.SAID === assembly.SAID ? assembly : a) || []
      });
    });
   }
   
   
}
